// Sends a booking to the Google Sheet web app. Does nothing until a URL is set.
// "no-cors" is needed for Apps Script, so the reply can't be read here: a booking
// that the script rejects looks the same as one it saved.
export const saveBookingToSheet = async (url, details) => {
  if (!url) return;

  await fetch(url, {
    method: "POST",
    mode: "no-cors",
    keepalive: true,
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify(details)
  });
};
